import React from 'react';
import {useTranslation} from 'react-i18next';

import type {ButtonProps} from '@pexip/components';
import {Button, onEnter} from '@pexip/components';

import {TestId} from '../../../test/testIds';
import {ClientCallType} from '@pexip/infinity';

export const JoinMeetingButton: React.FC<
    ButtonProps & {
        isDisabled?: boolean;
        onClick: () => void;
        callType?: ClientCallType;
    }
> = ({isDisabled, onClick, className, callType}) => {
    const {t} = useTranslation();

    const getButtonText = () => {
        switch (callType) {
            case ClientCallType.AudioSendRecvVideoSendRecvPresentationSendRecv:
                return t('common.join-with-video', 'Join with video');
            case ClientCallType.AudioSendRecvPresentationSendRecv:
                return t('common.join-with-audio', 'Join with audio');
            case ClientCallType.PresentationSendRecv:
                return t(
                    'common.join-with-presentation-only',
                    'Join with presentation only',
                );
            default:
                return t('common.join', 'Join');
        }
    };

    return (
        <Button
            className={className}
            isDisabled={isDisabled}
            onClick={onClick}
            onKeyDown={onEnter(onClick)}
            size="large"
            type="submit"
            variant="success"
            modifier="fullWidth"
            data-testid={TestId.ButtonJoinMeeting}
        >
            {getButtonText()}
        </Button>
    );
};
